module.exports = __webpack_public_path__ + "img/home_list_3.e284c3ac.png";